import React from 'react';
import { monthLabel } from '../../utils/money';
import { fmtDate } from '../../utils/dates';

// ترويسة خطاب الجهة: الشعار، رقم الخطاب، التاريخ الهجري، تاريخ القطع.
export default function FunderLetterHeader({ funder, period, subtitle }) {
  return (
    <div className="report-cover" style={{ borderRadius: 10, overflow: 'hidden', marginBottom: 16 }}>
      <div className="report-cover-inner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
        <div className="report-cover-text">
          <div className="report-cover-kicker">تقرير مالي شهري</div>
          <h1 className="report-cover-title">{funder?.name}</h1>
          <div className="report-cover-period">
            {monthLabel(period?.report_month)}
            {subtitle ? ` · ${subtitle}` : ''}
          </div>
          <div style={{ marginTop: 8, fontSize: 13, opacity: 0.92, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {period?.letter_no && <span>الخطاب: {period.letter_no}</span>}
            {period?.letter_date_hijri && <span>التاريخ: {period.letter_date_hijri} هـ</span>}
            {period?.cutoff_date && <span>تاريخ القطع: {fmtDate(period.cutoff_date)}</span>}
            {period?.status === 'draft' && <span style={{ fontWeight: 700 }}>● مسودّة</span>}
          </div>
        </div>
        {funder?.logo_path && (
          <img className="report-cover-logo" src={funder.logo_path} alt={funder.name} style={{ maxHeight: 72 }} />
        )}
      </div>
    </div>
  );
}
